var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col h-full",attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('el-loading',{attrs:{"loading":_vm.loading}}):_vm._e(),(_vm.visible)?_c('el-notification'):_vm._e(),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.slideVisible && !_vm.isAuthLayout)?_c('el-slide-tooltip'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }